import React, { useEffect, useState } from "react";
import "./cover-section.css";

interface ICoverComponentProps { }

export const CoverComponent: React.FC<ICoverComponentProps> = (
    props: ICoverComponentProps
) => {
    const [activeBgIndex, setActiveBgIndex] = useState(0);
    const [isZoomed, setIsZoomed] = useState(false);

    const bgs = [
        "/assets/img/blog/blog-2.jpg",
        "/assets/img/blog/blog-3.jpg",
        "/assets/img/blog/blog-6.jpg",
        "/assets/img/blog/blog-8.jpg",
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveBgIndex((prevIndex) => (prevIndex + 1) % bgs.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [bgs]);

    useEffect(() => {
        setIsZoomed(true);
        setTimeout(() => setIsZoomed(false), 4900);
    }, [activeBgIndex]);

    return (
        <>
            <section
                id="hero"
                className="hero section dark-background zoom-image-container"
            >
                <img loading="lazy"
                    src={bgs[activeBgIndex]}
                    alt="bg-cover-image"
                    className={isZoomed ? " zoomed" : ""}
                    style={{ height: "100%" }}
                />

                <div className="container">
                    <h2 data-aos="fade-up" data-aos-delay="100"
                    >
                        iTalent Outsourcing Services Private Ltd.
                    </h2>
                    <p data-aos="fade-up" data-aos-delay="200" >
                        Your trusted partner in Payroll, Statutory Compliance & Background Verification Services.
                    </p>
                </div>
            </section>
        </>
    );
};
